import {Locale} from '@hebcal/hdate';
import poData from './ashkenazi_komatz.po.js';
Locale.addLocale('ashkenazi_komatz', poData);
